import {useEffect, useMemo} from 'react'
import Loading from '@/components/Loading'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import type { PropsWithChildren } from 'react'
import {setLoggerUser} from "@/logger/logger";
import {useUser} from "@clerk/shared/react";

export interface ClerkJWTPayload {
  authToken: string
  [key: string]: unknown
}

export const AuthIntermediator = ({ children }: PropsWithChildren) => {
  const { isSignedIn, user: clerkUser } = useUser()
  const { data: user } = useCurrentUser()

  useEffect(() => {
    setLoggerUser(user, clerkUser)
  }, [user, clerkUser]);

  // Wait for token to be ready and query to succeed
  return useMemo(() => (isSignedIn && !!user?.token) ? <>{children}</> : <Loading message="Loading..." />, [isSignedIn, user, children])
}
